const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, InspectorControls } =
  wp.blockEditor;
const { useEffect, useState } = wp.element;
const { Button, PanelBody, PanelRow, IconButton } = wp.components;
const { __ } = wp.i18n;

registerBlockType('pg/partners-block', {
  title: __('Partners Block'),
  icon: 'groups',
  category: 'layout',
  attributes: {
    columns: {
      type: 'array',
      default: [
        {
          title: 'Partners',
          images: [
            {
              url: '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png',
              id: null,
              alt: '',
            },
            {
              url: '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png',
              id: null,
              alt: '',
            },
          ],
        },
      ],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { columns } = attributes;

    const updateColumnTitle = (value, index) => {
      const updatedColumns = [...columns];
      updatedColumns[index].title = value;
      setAttributes({ columns: updatedColumns });
    };

    const addImage = (image, columnIndex) => {
      const updatedColumns = [...columns];
      updatedColumns[columnIndex].images.push({
        url: image.url,
        id: image.id,
        alt: image.alt,
      });
      setAttributes({ columns: updatedColumns });
    };

    const removeImage = (columnIndex, imageIndex) => {
      const updatedColumns = [...columns];
      updatedColumns[columnIndex].images.splice(imageIndex, 1);
      setAttributes({ columns: updatedColumns });
    };

    const addColumn = () => {
      const newColumn = {
        title: 'New Column',
        images: [],
      };
      setAttributes({ columns: [...columns, newColumn] });
    };

    const removeColumn = (index) => {
      const updatedColumns = [...columns];
      updatedColumns.splice(index, 1);
      setAttributes({ columns: updatedColumns });
    };

    return (
      <>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <PanelRow>
              <Button isPrimary onClick={addColumn}>
                {__('Add Column')}
              </Button>
            </PanelRow>
          </PanelBody>
        </InspectorControls>
        <div className="partners-block">
          {columns.map((column, columnIndex) => (
            <div className="column" key={columnIndex}>
              <RichText
                tagName="h4"
                value={column.title}
                placeholder={__('Enter title...')}
                onChange={(value) => updateColumnTitle(value, columnIndex)}
              />
              <div className="logotypes">
                {column.images.map((image, imageIndex) => (
                  <div key={imageIndex} className="logotype-wrapper">
                    <img
                      src={image.url}
                      className="logotype"
                      alt={image.alt ?? ''}
                    />
                    <IconButton
                      icon="trash"
                      label={__('Remove Image')}
                      onClick={() => removeImage(columnIndex, imageIndex)}
                      className="bottomLeftButton remove-button"
                    />
                  </div>
                ))}
                <MediaUploadCheck>
                  <MediaUpload
                    onSelect={(media) => addImage(media, columnIndex)}
                    allowedTypes={['image']}
                    render={({ open }) => (
                      <Button
                        isPrimary
                        onClick={open}
                        className="topRightAboveButton"
                      >
                        {__('Add Image')}
                      </Button>
                    )}
                  />
                </MediaUploadCheck>
              </div>
              <Button
                onClick={() => removeColumn(columnIndex)}
                className="bottomRightButton remove-button"
              >
                {__('Remove Column')}
              </Button>
            </div>
          ))}
        </div>
      </>
    );
  },
  save: ({ attributes }) => {
    const { columns } = attributes;

    return (
      <div className="partners-block">
        {columns.map((column, columnIndex) => (
          <div className="column" key={columnIndex}>
            <h4>{column.title}</h4>
            <div className="logotypes">
              {column.images.map((image, imageIndex) => (
                <img
                  key={imageIndex}
                  src={image.url}
                  className="logotype"
                  alt={image.alt ?? ''}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  },
});
